import { Client } from "./_clientService";

const executeRequest = async (options: any) => {
  try {
    const resp = await new Client(options)[options.method]();
    return resp;
  } catch (error) {
    throw error;
  }
};

async function createOperatorGame(params: any) {
  return executeRequest({
    path: "/operatorGame/create",
    payload: params,
    method: "post",
  });
}

async function updateOperatorGame(operatorGameId: any, params: any) {
  return executeRequest({
    path: `/operatorGame/update/${operatorGameId}`,
    payload: params,
    method: "put",
  });
}

async function getOperatorGamesList(params: any) {
  let payload = {
    pageNo: params?.pageNo || 1,
    pageSize: params?.pageSize || 20,
    sortDirection: params?.sortDirection || 1,
  };

  if (params?.platform) payload["platform"] = params.platform;
  if (params?.operator) payload["operator"] = params.operator;
  if (params?.brand) payload["brand"] = params.brand;
  if (params?.isActive !== undefined && params?.isActive !== null && params?.isActive !== "") {
    payload["isActive"] = params.isActive;
  }

  if (params?.skipPagination) payload["skipPagination"] = true;

  const urlParams = new URLSearchParams(payload).toString();

  return executeRequest({
    path: `/operatorGame/list?${urlParams}`,
    method: "get",
  });
}

async function getOperatorGameInfo(operatorGameId: any) {
  if (!operatorGameId) throw new Error("No operator game id provided");

  return executeRequest({
    path: `/operatorGame/info/${operatorGameId}`,
    method: "get",
  });
}

async function deleteOperatorGame(operatorGameId: any) {
  if (!operatorGameId) throw new Error("No operator game id provided");

  return executeRequest({
    path: `/operatorGame/delete/${operatorGameId}`,
    method: "delete",
  });
}

async function testLaunchOperatorGame(params: any) {
  if (!params.operatorGameId) throw new Error("No operator game id provided");

  return executeRequest({
    path: "/operatorGame/test/launch",
    payload: params,
    method: "post",
  });
}

export {
  createOperatorGame,
  updateOperatorGame,
  getOperatorGamesList,
  getOperatorGameInfo,
  deleteOperatorGame,
  testLaunchOperatorGame,
};
